export const iconFontAwesomeMapsTags = (
	<i className="fa-solid fa-tags"></i>
);
